import { css, CSSObject } from '@emotion/react'
import { Color, CornerRadius, wideGamutColor, ZIndex } from '@opallabs/gem'
import { type WithRequiredTheme } from '@opallabs/lapidary'

export const overlayOverrides = css({
  position: 'fixed',
  insetBlockEnd: 0,
  insetInlineStart: 0,
  inlineSize: '100vi',
  blockSize: '100vb',
  // `+1` Required when modal open and fullscreen
  zIndex: ZIndex.Shroud.Overlay + 1,
})

export const overlayOverridesDynamic = ({
  theme,
}: WithRequiredTheme): CSSObject => ({
  backgroundColor: wideGamutColor(Color[theme].Surface.N200, 0.9),
})

export const contentOverrides = css({
  inlineSize: 680,
})

export const bodyOverrides = {
  marginBlockEnd: 0,
  marginInline: 0,
} as const

export const shortcutListOverrides: CSSObject = {
  blockSize: '330px',
  borderEndEndRadius: CornerRadius.XLarge,
  borderEndStartRadius: CornerRadius.XLarge,
  columns: 2,
  columnGap: 70,
  flexFlow: 'column wrap',
  paddingBlock: 20,
}
